import { Stack } from '@mui/material';
import { FC } from 'react';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export const QuestHeaderSkeleton: FC = () => {
    return (
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%', p: '10px 14px' }}>
            <ThemedSkeleton variant="text" width={120} height={16} />
            <Stack direction="row" alignItems="center" gap="4px">
                {[0, 1, 2, 3].map(i => (
                    <ThemedSkeleton key={i} variant="rectangular" width={12} height={12} />
                ))}
                <ThemedSkeleton variant="rectangular" width={16} height={16} />
            </Stack>
        </Stack>
    );
};
